import { useTranslation } from "react-i18next";
import type { ChangeSetState } from "../../../api/content/reviewDecoders";
import Chip from "../../../ui/feedback/Chip";
import type { ChipTone } from "../../../ui/styles/chipStyles";

const STATE_TONE: Readonly<Record<ChangeSetState, ChipTone>> = {
  open: "info",
  sent_back: "warning",
  merged: "success",
  scrapped: "danger",
};

export default function ReviewStateBadge({ state }: { state: ChangeSetState }) {
  const { t } = useTranslation();
  return <Chip tone={STATE_TONE[state]}>{t(`reviews.states.${state}`)}</Chip>;
}
